import React, { useState, useEffect, useMemo, useCallback } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../redux/actions'
import Header from '../../components/Header'
import menu from '../../constants/Menu'
import { imageBaseURL } from '../../services/defaultProps'
import { useHistory, useLocation } from 'react-router-dom'
import { FiArrowLeft } from 'react-icons/fi'
import IconMaterialDeveloperBoardWhite from '../../assets/images/icon_material_developer_board_white.svg'
import PerfilGridSkeleton from '../../components/PerfilGridSkeleton'
import API from '../../services/Api'
import '../../styles/containers/MoodboardCategory.css'
import moment from 'moment'
import useLanguage from '../../hooks/useLanguage'

const categories = [
  {
    name: 'Sobre a Cliente',
    image: '/assets/moodboard/about.jpg'
  },
  {
    name: 'Parte superior',
    image: '/assets/moodboard/upperPart.jpg'
  },
  {
    name: 'Parte inferior',
    image: '/assets/moodboard/lowerPart.jpg'
  },
  {
    name: 'Acessórios',
    image: '/assets/moodboard/bag.jpg'
  },
  {
    name: 'Sapatos',
    image: '/assets/moodboard/shoes.jpg'
  },
  {
    name: 'Outros',
    image: '/assets/moodboard/other.jpg'
  }
]

const MoodboardCategory = props => {
  const history = useHistory()
  const location = useLocation()

  const language = useLanguage()
  const [loading, setLoading] = useState(true)

  const isFixedCategory = useMemo(() => !(props.user.moodboardTemplate && props.user.moodboardTemplate.find(category => !categories.find(categoryFixed => categoryFixed.name === category.name) && category.released === 1)), [props.user.moodboardTemplate])

  const findImageCategory = useCallback(category => {
    const foundCategory = categories.find(categoryFixed => categoryFixed.name === category)

    if (foundCategory) {
      return foundCategory.image
    } else {
      setLoading(false)
    }
  }, [])

  const renderCategories = () => {
    return props.user.moodboardTemplate.map(category => {
      const image = category.image ? (imageBaseURL + category.image) : (isFixedCategory && findImageCategory(category.name))

      return (
        <div key={category.id} className='moodboard-category-item' onClick={() => history.push('/moodboard', { categoryId: category.id })}>
          {/* <div className="moodboard-category-item-notification" /> */}
          <div className='moodboard-category-item-inner' key={category.id}>
            <div className='moodboard-category-item-image' style={{ backgroundImage: `url('${image}')` }}>
              {!image && (
                <img src={IconMaterialDeveloperBoardWhite} alt='guia de estilo' className='moodboard-category-icon' />
              )}
            </div>
            <div className='moodboard-category-item-desc'>
              <p className='moodboard-category-item-name'>
                {category.name}
              </p>
            </div>
          </div>
        </div>
      )
    })
  }

  useEffect(() => {
    if (
      (!props.user.lastFetch || moment().diff(moment(props.user.lastFetch), 'hours') > 1) &&
      (!props.user.lastMoodboardFetch || moment().diff(moment(props.user.lastMoodboardFetch), 'hours') > 1)
    ) {
      API.getMoodboardTemplate(props.token)
        .then(moodboardTemplate => {
          props.setUserAttribute({ moodboardTemplate, lastMoodboardFetch: moment() })
        })
        .catch(err => {
          console.error(err)
          history.push('/')
        })
        .finally(() => setLoading(false))
    } else {
      setLoading(false)
    }
  }, [])

  return (
    <div className='moodboard-category-container'>
      <Header language={language} />
      <div className='moodboard-category-title'>
        <FiArrowLeft onClick={(location.state && location.state.mustPushOnGoBack) ? () => history.push('/') : history.goBack}
          size={24} color='var(--primary)' className='moodboard-category-goback' />
        <p>{menu.moodboard[language]}</p>
      </div>
      {!loading ? <div className='moodboard-category-list'>
        {renderCategories()}
      </div> : <PerfilGridSkeleton />}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    ...state.userReducer
  }
}

export default connect(mapStateToProps, actions)(MoodboardCategory)



// WEBPACK FOOTER //
// ./src/containers/Moodboard/MoodboardCategory.js